import {SHType} from "../common/SHType";

export enum ListlistTypeId {
    Root = 1,
    Category = 2,
    Series = 3
}

class _ListlistType extends SHType<ListlistTypeId> {
    constructor() {
        super(
            "ListlistType",
            [
                [ListlistTypeId.Root, "root"],
                [ListlistTypeId.Category, "category"],
                [ListlistTypeId.Series, "series"]
            ]
        );
    }

}

export const ListlistType = new _ListlistType();
